import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import * as CountryJson from 'assets/json/CountryCodes.json';
import { Subject, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { BrandService, ManufacturerService } from '@app/api/api';
//import { ModalCreateBrandComponent } from '../../brand-management/modal-create-brand/modal-create-brand.component';
@Component({
  selector: 'meu-modal-create-producer',
  templateUrl: './modal-create-producer.component.html',
  styleUrls: ['./modal-create-producer.component.scss'],
})
export class ModalCreateProducerComponent implements OnInit {
  constructor(
    public dialogRef: MatDialogRef<ModalCreateProducerComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private changeDetectorRef: ChangeDetectorRef,
    private brandService: BrandService,
    private producerService: ManufacturerService,
    public dialog: MatDialog
  ) {}
  page = 1;
  filter = '';
  totalPage = 0;
  lstCountry: any = [];
  isEdit: boolean = false;
  hasFormErrors: boolean = false;
  lstCountryJson: any = [];
  selectBrandID = '';
  brand_Name = '';
  //dataSearchBasic: any = '';
  filterBrand = '';
  listBrand = [];
  listCheckBrandID = [];
  filteredOptionsNation: Observable<string[]>;
  producerForm = new FormGroup({
    name: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    code: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),
    email: new FormControl('', [Validators.required, Validators.email]),
    phone: new FormControl('', [Validators.required, Validators.pattern('^(?!\\s*$).+')]),

    nation: new FormControl(''),
    //brand_id:new FormControl('',[Validators.required])
  });

  public controlSearch: FormControl = new FormControl();
  public keyUp = new Subject<KeyboardEvent>();
  ngOnInit() {
    this.lstCountryJson = Object.values(JSON.parse(JSON.stringify(CountryJson.default)));
    this.lstCountry = [...this.lstCountryJson.map((x) => x.name)];
    if (this.data.id != null) {
      this.isEdit = true;
      this.getProducerByID(this.data.id);
    }
    // this.keyUp.pipe(map((event) => event), debounceTime(300)).subscribe((value) => {
    // 	this.dataSearchBasic = value;
    // 	this.filterBrand = 'name@=*' + this.dataSearchBasic;
    // 	this.page = 1;
    // 	this.listBrand = [];
    // 	this.getListBrand()
    //   });
    //this.getListBrand();
    if (this.data.name != null) {
      this.producerForm.patchValue({
        name: this.data.name,
      });
    }
    this.filteredOptionsNation = this.producerForm.get('nation').valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
  }
  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();

    return this.lstCountry.filter((option) => option.toLowerCase().includes(filterValue));
  }
  getProducerByID(id) {
    this.producerService.apiManufacturerIdGet(id).subscribe((res) => {
      if (res.success) {
        this.producerForm.patchValue({
          name: res.data.name,
          code: res.data.code,
          nation: res.data.nation,
          email: res.data.email,
          phone: res.data.phone,
          //brand_id:res.data.brand_id,
        });
      }
    });
  }

  getListBrand() {
    this.brandService.apiBrandsGet(this.filterBrand, '', this.page, 10).subscribe((res) => {
      if (res.success) {
        this.totalPage = Math.ceil(res.data.total / 10);
        for (let i = 0; i < res.data.collection.length; i++) {
          let index = this.listBrand.findIndex((x) => x.id == res.data.collection[i].id);
          if (index == -1) {
            this.listBrand.push({
              id: res.data.collection[i].id,
              name: res.data.collection[i].name,
            });
            this.listCheckBrandID.push(res.data.collection[i].id);
          }
        }
        // if(this.data.id!=null){
        // 	let check=this.listCheckBrandID.includes(this.producerForm.value.brand_id.toString());
        //     if(!check){
        // 	  this.loadMore(event);
        //     }
        // }
      }
      this.changeDetectorRef.detectChanges();
    });
  }
  loadMore(e) {
    this.page = this.page + 1;
    this.getListBrand();
  }
  search(event) {}
  chooseBrand(item) {
    this.brand_Name = item.name;
  }
  //   addNewBrand() {
  //     const dialogRef = this.dialog.open(ModalCreateBrandComponent, {
  //       width: '900px',
  //       data: { name: this.controlSearch.value }
  //     });
  //     dialogRef.afterClosed().subscribe(result => {
  //       if (result && result.event) {
  //         this.filterBrand = ''
  //         this.page = 1;
  //         this.listBrand = [];
  //         this.getListBrand()
  //         this.changeDetectorRef.detectChanges()
  //         //this.selectBrandID = '25d04775-b641-419e-a579-1d2cffaead7a'
  //       }

  //     });
  //   }

  save() {
    this.hasFormErrors = true;
    const controls = this.producerForm.controls;
    if (this.producerForm.invalid) {
      Object.keys(controls).forEach((controlName) => controls[controlName].markAsTouched());
      return;
    }

    if (!this.isEdit) {
      this.producerService.apiManufacturerPost(this.producerForm.value).subscribe((res) => {
        if (res.success) {
          this.dialogRef.close({ event: true, type: 'create', newItem: res.data });
        } else {
          this.dialogRef.close({ event: false });
        }
      });
    } else {
      this.producerService
        .apiManufacturerIdPut(this.data.id, this.producerForm.value)
        .subscribe((res) => {
          if (res.success) {
            this.dialogRef.close({ event: true });
          } else {
            this.dialogRef.close({ event: false });
          }
        });
    }
  }

  closeModal() {
    this.dialogRef.close();
  }
}
